import { NgFor, NgIf, NgClass } from '@angular/common';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { debounceTime, filter, map, of, repeat, Subject, switchMap, takeUntil } from 'rxjs';
import { ProductSearchInterface, ProductVariation } from 'src/_lib/interfaces/product.interface';
import { CategoryService } from 'src/_lib/service/category.service';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';
import { ProductService } from 'src/_lib/service/product.service';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { environment } from 'src/environments/environment.prod';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss', './header-search-ch2.component.scss', './header-search-ch3.component.scss', './header-search-ch4.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, NgFor, NgIf, NgClass],
})
export class HeaderSearchComponent {
  searchValueByPartName: string = '';
  private searchSubject = new Subject<string>();
  searchResultArrayByPartName: Array<ProductSearchInterface>;
  commonImagePath: string = environment.commonImagePath;
  searchResultArrayByCatName: any = [];
  product_variation_key = null;
  isProductPage: boolean = false;
  product_key: number = null;
  defaultArrayList: Array<{ name: string }> = [];
  showDefault: boolean = false;
  categoryName: string;
  blackSearch = environment.blackSearch;
  chTheme2 = environment.chTheme2;
  chTheme3 = environment.chTheme3;
  chTheme4 = environment.chTheme4;
  chTheme5 = environment.chTheme5;
  chTheme6 = environment.chTheme6;
  chTheme7 = environment.chTheme7;
  chTheme9 = environment.chTheme9;
  placeholder_title = environment.placeholder_title;
  isSearchByVehicleDisabled: boolean = false;
  noResult: boolean = false;
  private destroy$ = new Subject<void>();
  private navigation$ = this.router.events.pipe(
    filter(event => event instanceof NavigationStart)
  );
  @Output() showSearch = new EventEmitter<boolean>();

  constructor(
    private productService: ProductService,
    private categorySevice: CategoryService,
    private commonService: CommanpageService,
    private comm: CommunicationService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private browser: BrowserService,
    private dynamicThemeClassService: DynamicThemeClassService
  ) { }

   themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }  

  ngOnInit() {
    this.comm.showVehicleButton.subscribe(() => {
      const vehicleBtnData = this.commonService.isSearchByVehicleDisabled()
      this.isSearchByVehicleDisabled = vehicleBtnData?.do_not_show;
    });
    this.product_variation_key = +this.browser.localStorage?.getItem('selectedproductvariationkey') || null;
    this.searchChangeByPartName();
    this.route.queryParams.subscribe((params) => {
      this.searchValueByPartName = params['value'];
    })
  }

  searchByCateName(): void {
    const keyword = this.searchValueByPartName.trim().toLowerCase();
    if (!keyword) {
      this.searchResultArrayByCatName = [];
      this.noResult = false;
      return;
    }
    this.categorySevice.categoryBySearchResults(keyword).subscribe({
      next: (response) => {
        if (response[0].success === false) {
          this.searchResultArrayByCatName = [];
          this.noResult = true;
        } else {
          const data = response[0]?.data || [];
          this.searchResultArrayByCatName = data;
          this.noResult = false;
        }
      },
      error: (err) => {
        this.searchResultArrayByCatName = [];
        console.error('Error fetching search results:', err);
      }
    });
  }

  searchChangeByPartName() {
    this.searchSubject
      .pipe(
        debounceTime(100),
        map((v) => v.trim()),
        switchMap((q) => {
          const data = {
            keyword: q,
            flag: true,
            limit: 0,
            offset: 0,
            brand_keys: []
          };
          if (q) {
            return this.productService.productBySearchResults(data);
          } else {
            return of(this.searchResultArrayByPartName = []);
          }
        }),
        takeUntil(this.navigation$),
        repeat(),
        takeUntil(this.destroy$)
      ).subscribe({
        next: (resultArray: any) => {
          const keyword = this.searchValueByPartName.trim().toLowerCase();
          if (!keyword) {
            this.searchResultArrayByPartName = [];
            this.noResult = false;
            return;
          }
          if (resultArray[0].success === false) {
            this.searchResultArrayByPartName = [];
            this.noResult = true;
            return;
          }
          this.noResult = false;
          const filteredResults = resultArray?.[0]?.data
            // .map((product) => {
            //   const variations = Array.isArray(product.product_variations)
            //     ? product.product_variations
            //     : [];
            //   const isNameMatch = product.name.toLowerCase().includes(keyword);
            //   const hasMatchingSku = variations.some((v) =>
            //     v?.sku?.toLowerCase().includes(keyword),
            //   );
            //   if (isNameMatch || hasMatchingSku) {
            //     return {
            //       ...product,
            //       product_variations: variations,
            //     };
            //   }
            //   return null;
            // })
            .filter((product) => product !== null) as ProductSearchInterface[];
          this.searchResultArrayByPartName = filteredResults;
        },
        error: (err) => {
          this.searchResultArrayByPartName = [];
          console.error('Search error:', err);
        },
      });
  }

  highlightKeyword(text: string): string {
    const keyword = this.searchValueByPartName?.trim();
    text = text?.replace(/\\"/g, '"').replace(/[\/]/g, '’’');
    if (!keyword) return text;
    const words = keyword.split(/\s+/).filter(w => w).map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const regex = new RegExp(`(${words.join('|')})`, 'gi');
    return text.replace(regex, '<strong>$1</strong>');
  }

  onClickSearchByPartName(): void {
    this.searchResultArrayByPartName = [];
    this.searchResultArrayByCatName = [];
    this.categoryName = null;
    this.noResult = false;
  }

  onInputvalueChangeByPartName(): void {
    const keyword = this.searchValueByPartName.trim();
    if (keyword?.length === 0 || !keyword) {
      this.searchResultArrayByPartName = [];
      this.searchResultArrayByCatName = [];
      this.noResult = false;
      return;
    } else if (keyword?.length >= 2) {
      this.searchSubject.next(keyword);
    } else {
      this.searchResultArrayByPartName = [];
      this.searchResultArrayByCatName = [];
    }
    // if (this.categoryName == 'Search By Part Or Part#') {
    //   this.searchSubject.next(keyword);
    // } else if (this.categoryName == 'Search By Category') {
    //   this.searchByCateName();
    // }
  }

  async onClickSearchByPartNameResult(productKey: number, productName: string) {
    const name: string = this.commonService.setUrlNameField(productName);
    this.browser.localStorage?.removeItem('selectedproductvariationkey');
    this.product_variation_key = null;
    if (this.isProductPage && this.product_key != productKey) {
      this.browser.localStorage?.setItem('selectedproductkey', String(productKey));
      this.product_key = productKey;
      this.comm.searchByPartNameProductKeyChange.next(null);
    } else if (!this.isProductPage && this.product_key != productKey) {
      this.browser.localStorage?.setItem('selectedproductkey', String(productKey));
      this.product_key = productKey;
    }
    const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
    const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
    updatedProducts.unshift(productKey);
    this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
    await this.commonService.productRedirection(productName, productKey)
    this.searchValueByPartName = '';
    this.searchSubject.next('');
    this.searchResultArrayByPartName = [];
    this.searchResultArrayByCatName = [];
    this.noResult = false;
    this.categoryName = null;
    this.showSearch.emit(false);
    this.comm.serchByPartHashKeyChange.next(null);
  }

  async onClickVariationResult(skuName: string, variation: ProductVariation) {
    const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
    const productKey = variation.product_key;
    const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
    updatedProducts.unshift(productKey);
    this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
    await this.commonService.productRedirection(skuName, variation.product_key)
    this.searchValueByPartName = '';
    this.searchResultArrayByPartName = [];
    this.searchResultArrayByCatName = [];
    this.categoryName = null;
    this.noResult = false;
    this.showSearch.emit(false);
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event) {
    const clickedInside = (event.target as HTMLElement).closest('.search-form, .search-kds-form');
    const clickedOutside = (event.target as HTMLElement).closest('.search-wrapper');
    const clickedIcon = (event.target as HTMLElement).closest('.search-icon');
    const dropdownItem = (event.target as HTMLElement).closest('.dropdown-item');
    if (!clickedInside) {
      this.searchResultArrayByPartName = [];
      this.searchResultArrayByCatName = [];
      this.showDefault = false;
      this.noResult = false;
    }
    if (!clickedOutside && !clickedIcon && !dropdownItem) {
      this.showSearch.emit(false);
    }
  }

  defaultItems() {
    this.showDefault = true;
    if (!this.categoryName) {
      if (!this.isSearchByVehicleDisabled) {
        this.defaultArrayList = [
          { name: 'Search By Category' },
          { name: 'Search By Make & Model' },
          { name: 'Search By Part Or Part#' },
        ];
      } else {
        this.defaultArrayList = [
          { name: 'Search By Category' },
          { name: 'Search By Part Or Part#' },
        ];
      }
    } else {
      this.defaultArrayList = [];
      this.showDefault = false;
    }
  }

  select_Category(name: string) {
    if (name == 'Search By Make & Model') {
      this.openVechicleSearchPopup();
    }
    this.categoryName = name;
    this.showDefault = false;
  }

  async subCategoriesRedirection(subcategory: any) {
    await this.commonService.categoryRedirection(subcategory.name, subcategory.category_key);
    this.searchValueByPartName = '';
    this.searchResultArrayByCatName = [];
    this.searchResultArrayByPartName = [];
    this.categoryName = null;
    this.noResult = false;
    this.showSearch.emit(false);
  }

  openVechicleSearchPopup(): void {
    const opendilog = this.dialog.open(SearchByVehicleComponent, {
      width: '600px',
      panelClass: 'search-by-vehicle-dialog'
    });
    opendilog.afterClosed().subscribe(() => {
      this.searchValueByPartName = '';
      this.searchResultArrayByPartName = [];
      this.searchResultArrayByCatName = [];
      this.categoryName = null;
      this.noResult = false;
      this.showSearch.emit(false);
    });
  }

  onEnterClickSearch(value: string) {
    if (value) {
      this.router.navigate(['/search'], {
        queryParams: { value: value },
      });
      this.onClickSearchByPartName();
    }
  }
}